module.exports = __webpack_public_path__ + "img/f-thermometer-img5-2.6b8df1f1.png";